define([
    "dojo/_base/declare"
], function (declare) {

    var EDITABLE_TRUE_CLASS = "mwEditableTrue";
    return declare(null, {
        editable: true,

        _setEditableAttr: function (value) {
            this.inherited(arguments);
            if (value) {
                this.domNode.classList.add(EDITABLE_TRUE_CLASS);
            } else {
                this.domNode.classList.remove(EDITABLE_TRUE_CLASS);
            }
            this._set("editable", value);
        }
    });
});



